// extracted by mini-css-extract-plugin
export default {"main":"Textarea_main__OPCNV","labelCon":"Textarea_labelCon__+b5ul","label":"Textarea_label__dwbnR","input":"Textarea_input__eaUqg","error":"Textarea_error__wHnOO"};